//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseViewObject = require('@/tbs/model/vo/BaseViewObject')
const ClassFunc = require('@/tbs/util/ClassFunc')
const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const MatchSignupPayment = require('@/tbs/model/to/MatchSignupPayment')
const matchSignupPayment = new MatchSignupPayment
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchSignupPayment = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseViewObject, arguments)
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSignupPayment.prototype = {
    /* The view object name */
    name: 'matchSignup',
    /* The view object instance */
    view: {
        manage: [
            {
                name: 'signupList',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetUnionMatchSignupSpuList',
                query: {
                    unionMatchId: 'id',
                },
                basePath: 'data.list',
                rule: {
                    id: 'id',
                    matchId: 'unionMatchId',
                    name: 'name',
                    statusLabel: '$regBeginDate,regEndDate',
                    imageUrl: '$detailPic,logo',
                    startDateTime: '$regBeginDate',
                    endDateTime: '$regEndDate',
                    teamTotal: 'teamCount',
                }
            }
        ],
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateUnionMatchSignupSpu',
            basePath: '',
            rule: {
                unionMatchId: 'matchId',
                name: 'name',
                description: 'description',
                detailPic: '$imageList',
                regBeginDate: '$startDateTime',
                regEndDate: '$endDateTime',
                regUpdateEndDate: '$frozenDateTime',
                skus: '$matchGroupId,teamTotal',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateUnionMatchSignupSpu',
            basePath: '',
            rule: {
                spuId: 'id',
                name: 'name',
                description: 'description',
                detailPic: '$imageList',
                regBeginDate: '$startDateTime',
                regEndDate: '$endDateTime',
                regUpdateEndDate: '$frozenDateTime',
                skus: '$matchGroupId,teamTotal,skuId',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetUnionMatchSignupSpuDetail',
            query: {
                spuId: 'id',
            },
            basePath: 'data',
            rule: {
                id: 'id',
                matchId: 'unionMatchId',
                name: 'name',
                description: 'description',
                imageUrls: '$detailPic',
                startDateTime: '$regBeginDate',
                endDateTime: '$regEndDate',
                frozenDateTime: '$regUpdateEndDate',
                teamTotal: 'skus.0.teamCount',
                skuId: 'skus.0.id',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderImageUrls: function(detailPic) {
        if (detailPic && detailPic.length > 0) {
            const detailPicArr = detailPic.split(',')
            return detailPicArr
        }
        return []
    },
    renderImageUrl: function(detailPic, logo) {
        console.log('renderImageUrl', detailPic, logo)
        if (detailPic && detailPic.length > 0) {
            const detailPicArr = detailPic.split(',')
            return detailPicArr[0]
        }
        else {
            return logo
        }
    },
    renderStatusLabel: function(regBeginDate, regEndDate) {
        const currentTime = (new Date).getTime()
        if (regBeginDate && regEndDate) {
            if (new Date(regBeginDate).getTime() < currentTime 
                && new Date(regEndDate).getTime() > currentTime) {
                return matchSignupPayment.localeProp('match-signup-status-type-2')
            }
        }
        else if (regEndDate) {
            if (new Date(regEndDate).getTime() > currentTime) {
                return matchSignupPayment.localeProp('match-signup-status-type-2')
            }
        }
        return ''
    },
    renderStartDateTime: function(regBeginDate) {
        regBeginDate = this._renderStartDateTime(regBeginDate)
        if (regBeginDate) {
            return new Date(regBeginDate)
        }
    },
    renderEndDateTime: function(regEndDate) {
        regEndDate = this._renderEndDateTime(regEndDate)
        if (regEndDate) {
            return new Date(regEndDate)
        }
    },
    renderFrozenDateTime: function(regUpdateEndDate) {
        regUpdateEndDate = this._renderEndDateTime(regUpdateEndDate)
        if (regUpdateEndDate) {
            return new Date(regUpdateEndDate)
        }
    },
    formatDetailPic: function(imageList) {
        const assetList = []
        for (let i = 0; i < imageList.length; i++) {
            let image = imageList[i]
            if (image.file) {
                assetList.push(image)
            }
            else if (image.value) {
                assetList.push(image.value)
            }
        }
        return assetList
    },
    formatRegBeginDate: function(startDateTime) {
        if (startDateTime) {
            startDateTime = DateTimeFunc.formatDate(startDateTime, 'yyyy-MM-ddThh:mm:ss+0800')
        }
        return this._formatStartDateTime(startDateTime)
    },
    formatRegEndDate: function(endDateTime) {
        if (endDateTime) {
            endDateTime = DateTimeFunc.formatDate(endDateTime, 'yyyy-MM-ddThh:mm:ss+0800')
        }
        return this._formatEndDateTime(endDateTime)
    },
    formatRegUpdateEndDate: function(frozenDateTime) {
        if (frozenDateTime) {
            frozenDateTime = DateTimeFunc.formatDate(frozenDateTime, 'yyyy-MM-ddThh:mm:ss+0800')
        }
        return this._formatEndDateTime(frozenDateTime)
    },
    formatSkus: function(matchGroupId, teamTotal, skuId) {
        console.log('formatSkus', matchGroupId, teamTotal)
        const sku = {
            matchId: matchGroupId,
            teamCount: Number(teamTotal),
        }
        if (skuId) {
            sku.id = skuId
        }
        const skus = [sku]
        return JSON.stringify(skus)
    },
}

//--------------------------------------------------
// extends the BaseViewObject
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_MatchSignupPayment, BaseViewObject)

module.exports = tbs_model_vo_MatchSignupPayment